import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest, getUserDetails } from "../../services/apiRequest";
import { requestType } from "../../services/requests";
import { addToLoader } from "../loader/loaderSlice";

const initialState = {
    data: {},
    dummyData: {
        proposalsCreated: 1200,
        itinerariesSelected: 1200,
        agentsCreatingProposals: 892,
        proposalsCreatedByMonth: [
            {
                month: "jan",
                value: 23,
            },
            {
                month: "feb",
                value: 647,
            },
            {
                month: "mar",
                value: 874,
            },
            {
                month: "apr",
                value: 1342,
            },
            {
                month: "may",
                value: 233,
            },
            {
                month: "jun",
                value: 565,
            },
            {
                month: "jul",
                value: 1555,
            },
            {
                month: "aug",
                value: 132,
            },
            {
                month: "sep",
                value: 97,
            },
            {
                month: "oct",
                value: 457,
            },
            {
                month: "nov",
                value: 7,
            },
            {
                month: "dec",
                value: 7,
            },
        ],
        agentsSignedByMonth: [
            {
                month: "jan",
                value: 23,
            },
            {
                month: "feb",
                value: 647,
            },
            {
                month: "mar",
                value: 874,
            },
            {
                month: "apr",
                value: 1342,
            },
            {
                month: "may",
                value: 233,
            },
            {
                month: "jun",
                value: 565,
            },
            {
                month: "jul",
                value: 1555,
            },
            {
                month: "aug",
                value: 132,
            },
            {
                month: "sep",
                value: 97,
            },
            {
                month: "oct",
                value: 457,
            },
            {
                month: "nov",
                value: 7,
            },
            {
                month: "dec",
                value: 7,
            },
        ],
        productMix: [
            {
                name: "Rest of World",
                valueNr: 9573,
            },
            {
                name: "Europe",
                valueNr: 6356,
            },
            {
                name: "Caribbean & Bahamas",
                valueNr: 973,
            },
            {
                name: "Other",
                valueNr: 73,
            },
        ],
        sailingDates: [
            {
                name: "Q1",
                valueNr: 573,
                year: "2023",
            },
            {
                name: "Q2",
                valueNr: 1356,
                year: "2023",
            },
            {
                name: "Q3",
                valueNr: 973,
                year: "2023",
            },
            {
                name: "Q4",
                valueNr: 73,
                year: "2023",
            },
            {
                name: "Q1",
                valueNr: 234,
                year: "2024",
            },
            {
                name: "Q2",
                valueNr: 7545,
                year: "2024",
            },
            {
                name: "Q3",
                valueNr: 1235,
                year: "2024",
            },
            {
                name: "Q4",
                valueNr: 97,
                year: "2024",
            },
            {
                name: "Q1",
                valueNr: 343,
                year: "2025",
            },
            {
                name: "Q2",
                valueNr: 618,
                year: "2025",
            },
            {
                name: "Q3",
                valueNr: 352,
                year: "2025",
            },
            {
                name: "Q4",
                valueNr: 2287,
                year: "2025",
            },
        ],
        topTenItineraries: [
            {
                feature_img:
                    "https://f.hubspotusercontent10.net/hubfs/3921613/BRAND-RESOURCES-APP-UK-DO-NOT-TOUCH-UNLESS-AUTHORISED/itinerary-sales-kits/itineraries/feature_img/coco_cay_feature_image_1.jpg",
                duration: "7",
                title: "Night Western Caribbean & Perfect Day",
                port_name: "Southampton, England",
                ship_name: "Anthem of the Seas",
                label: "Focus Holiday",
            },
            {
                feature_img:
                    "https://f.hubspotusercontent10.net/hubfs/3921613/BRAND-RESOURCES-APP-UK-DO-NOT-TOUCH-UNLESS-AUTHORISED/itinerary-sales-kits/itineraries/feature_img/coco_cay_feature_image_1.jpg",
                duration: "7",
                title: "Night Western Caribbean & Perfect Day",
                port_name: "Southampton, England",
                ship_name: "Anthem of the Seas",
                label: "",
            },
            {
                feature_img:
                    "https://f.hubspotusercontent10.net/hubfs/3921613/BRAND-RESOURCES-APP-UK-DO-NOT-TOUCH-UNLESS-AUTHORISED/itinerary-sales-kits/itineraries/feature_img/coco_cay_feature_image_1.jpg",
                duration: "7",
                title: "Night Western Caribbean & Perfect Day",
                port_name: "Southampton, England",
                ship_name: "Anthem of the Seas",
                label: "Focus Holiday",
            },
            {
                feature_img:
                    "https://f.hubspotusercontent10.net/hubfs/3921613/BRAND-RESOURCES-APP-UK-DO-NOT-TOUCH-UNLESS-AUTHORISED/itinerary-sales-kits/itineraries/feature_img/coco_cay_feature_image_1.jpg",
                duration: "7",
                title: "Night Western Caribbean & Perfect Day",
                port_name: "Southampton, England",
                ship_name: "Anthem of the Seas",
                label: "",
            },
            {
                feature_img:
                    "https://f.hubspotusercontent10.net/hubfs/3921613/BRAND-RESOURCES-APP-UK-DO-NOT-TOUCH-UNLESS-AUTHORISED/itinerary-sales-kits/itineraries/feature_img/coco_cay_feature_image_1.jpg",
                duration: "7",
                title: "Night Western Caribbean & Perfect Day",
                port_name: "Southampton, England",
                ship_name: "Anthem of the Seas",
                label: "Focus Holiday",
            },
            {
                feature_img:
                    "https://f.hubspotusercontent10.net/hubfs/3921613/BRAND-RESOURCES-APP-UK-DO-NOT-TOUCH-UNLESS-AUTHORISED/itinerary-sales-kits/itineraries/feature_img/coco_cay_feature_image_1.jpg",
                duration: "7",
                title: "Night Western Caribbean & Perfect Day",
                port_name: "Southampton, England",
                ship_name: "Anthem of the Seas",
                label: "Focus Holiday",
            },
            {
                feature_img:
                    "https://f.hubspotusercontent10.net/hubfs/3921613/BRAND-RESOURCES-APP-UK-DO-NOT-TOUCH-UNLESS-AUTHORISED/itinerary-sales-kits/itineraries/feature_img/coco_cay_feature_image_1.jpg",
                duration: "7",
                title: "Night Western Caribbean & Perfect Day",
                port_name: "Southampton, England",
                ship_name: "Anthem of the Seas",
                label: "",
            },
            {
                feature_img:
                    "https://f.hubspotusercontent10.net/hubfs/3921613/BRAND-RESOURCES-APP-UK-DO-NOT-TOUCH-UNLESS-AUTHORISED/itinerary-sales-kits/itineraries/feature_img/coco_cay_feature_image_1.jpg",
                duration: "7",
                title: "Night Western Caribbean & Perfect Day",
                port_name: "Southampton, England",
                ship_name: "Anthem of the Seas",
                label: "",
            },
            {
                feature_img:
                    "https://f.hubspotusercontent10.net/hubfs/3921613/BRAND-RESOURCES-APP-UK-DO-NOT-TOUCH-UNLESS-AUTHORISED/itinerary-sales-kits/itineraries/feature_img/coco_cay_feature_image_1.jpg",
                duration: "7",
                title: "Night Western Caribbean & Perfect Day",
                port_name: "Southampton, England",
                ship_name: "Anthem of the Seas",
                label: "",
            },
            {
                feature_img:
                    "https://f.hubspotusercontent10.net/hubfs/3921613/BRAND-RESOURCES-APP-UK-DO-NOT-TOUCH-UNLESS-AUTHORISED/itinerary-sales-kits/itineraries/feature_img/coco_cay_feature_image_1.jpg",
                duration: "7",
                title: "Night Western Caribbean & Perfect Day",
                port_name: "Southampton, England",
                ship_name: "Anthem of the Seas",
                label: "Focus Holiday",
            },
        ],
    },
    loading: true,
    error: false,
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const getAnaylticsData = createAsyncThunk(
    "analyticsData/get",
    async ({ travelAgencyUid, year, month, country }, thunkAPI) => {
        thunkAPI.dispatch(addToLoader(true));
        const response = await apiRequest({
            payload: {
                data: {
                    user_uid: getUserDetails().user_details.uid,
                    travel_agency_uid: travelAgencyUid,
                    year: year,
                    month: month,
                    country: country,
                },
            },
            requestType: requestType.getHolidayAnalytics,
        });
        thunkAPI.dispatch(addToLoader(false));
        return response.data.data;
    }
);

export const analyticsSlice = createSlice({
    name: "analyticsData",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {},
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(getAnaylticsData.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAnaylticsData.fulfilled, (state, { payload }) => {
                // When the API call is successful and we get some data,the data becomes the `fulfilled` action payload
                state.loading = false;
                state.data = payload;
            })
            .addCase(getAnaylticsData.rejected, (state) => {
                state.loading = false;
                state.error = true;
            });
    },
});

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.analytics.value)`
export const selectAnalyticsData = (state) => state.analyticsData.data;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.

export default analyticsSlice.reducer;
